/* GhostOud theme — scroll reveals, scent trail, header dock, cart helpers */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- hero wordmark stagger ---------- */
  document.querySelectorAll('.wordmark i').forEach(function (el, i) {
    el.style.animationDelay = (0.35 + i * 0.075) + 's';
  });

  /* ---------- reveal on scroll ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });

  function observeAll() {
    document.querySelectorAll('.rv:not(.in), .rv-l:not(.in), .step:not(.in)').forEach(function (el) {
      io.observe(el);
    });
  }
  observeAll();
  document.addEventListener('shopify:section:load', observeAll);

  /* ---------- header dock + scent trail + hero parallax ---------- */
  var hdr = document.getElementById('hdr'),
      trail = document.getElementById('trail'),
      cap = document.getElementById('trailCap'),
      glow = document.querySelector('.hero-glow'),
      inner = document.querySelector('.hero-inner'),
      queued = false;

  function frame() {
    var y = window.scrollY,
        max = document.documentElement.scrollHeight - window.innerHeight,
        p = max > 0 ? Math.min(y / max, 1) : 0;

    if (hdr) hdr.classList.toggle('docked', y > 40);
    if (trail) trail.style.setProperty('--progress', (p * 100).toFixed(2) + '%');
    if (cap) {
      cap.style.setProperty('--capTop', (p * 100).toFixed(2) + '%');
      cap.style.opacity = y > 60 ? 1 : 0;
    }
    if (!reduce && inner && y < window.innerHeight) {
      if (glow) glow.style.transform = 'translate(-50%,-50%) translateY(' + (y * 0.22) + 'px)';
      inner.style.transform = 'translateY(' + (y * -0.10) + 'px)';
      inner.style.opacity = Math.max(0, 1 - y / (window.innerHeight * 0.85));
    }
    queued = false;
  }
  window.addEventListener('scroll', function () {
    if (!queued) { queued = true; requestAnimationFrame(frame); }
  }, { passive: true });
  frame();

  /* ---------- format filter (homepage grid) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.filter');
    if (!btn) return;
    var group = btn.closest('.filters'),
        f = btn.dataset.f;
    group.querySelectorAll('.filter').forEach(function (b) { b.classList.toggle('on', b === btn); });
    document.querySelectorAll('.vial-card').forEach(function (c) {
      c.classList.toggle('hide', f !== 'all' && c.dataset.fmt !== f);
    });
  });

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-step]');
    if (!step) return;
    var input = step.parentNode.querySelector('input');
    var val = parseInt(input.value, 10) || 1;
    var max = parseInt(input.getAttribute('max'), 10) || 9999;
    val += parseInt(step.dataset.step, 10);
    input.value = Math.min(Math.max(val, 1), max);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- toast ---------- */
  var toast = document.getElementById('toast'), tid;
  window.ghostToast = function (msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('up');
    clearTimeout(tid);
    tid = setTimeout(function () { toast.classList.remove('up'); }, 2600);
  };

  /* ---------- add to cart without leaving the page ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.querySelector('span').textContent : '';
    if (btn) { btn.disabled = true; btn.querySelector('span').textContent = 'Adding…'; }

    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        if (item.status) throw new Error(item.description || 'Could not add');
        window.ghostToast((item.product_title || 'Item') + ' added');
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count ? '' : 'none';
        });
      })
      .catch(function (err) { window.ghostToast(err.message || 'Sold out'); })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.querySelector('span').textContent = original; }
      });
  });

  /* ---------- cart page: update line quantities ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(input.dataset.lineQty, 10), quantity: parseInt(input.value, 10) })
    }).then(function () { window.location.reload(); });
  });

  /* ---------- product page: thumbnail switching ---------- */
  document.querySelectorAll('.pdp-thumbs button').forEach(function (b) {
    b.addEventListener('click', function () {
      var main = document.querySelector('.pdp-hero img');
      if (!main) return;
      main.src = b.dataset.full;
      main.srcset = '';
      document.querySelectorAll('.pdp-thumbs button').forEach(function (x) {
        x.setAttribute('aria-current', x === b ? 'true' : 'false');
      });
    });
  });
})();
